import {
  Input,
  FormControl,
  FormLabel,
  InputGroup,
  InputRightElement,
  Icon,
  Text,
} from '@chakra-ui/react';
import { useState } from 'react';
import { UseFormMethods } from 'react-hook-form';
import {
  SvgVisibilityOffOutlined,
  SvgVisibilityOutlined,
} from 'src/components/icons';

export function PasswordInput({
  title = 'Password',
  name = 'password',
  placeholder = 'Create a password',
  methods,
  id,
}: {
  id?: string;
  title?: string;
  name?: string;
  placeholder?: string;
  methods: UseFormMethods<any>;
}) {
  const [visible, setVisible] = useState(false);

  const toggleVisible = () => setVisible((prevVisible) => !prevVisible);

  return (
    <FormControl id={id}>
      <FormLabel mb={0} fontSize="sm">
        {title}
      </FormLabel>
      <InputGroup variant="flushed">
        <Input
          data-testid={id}
          name={name}
          autoComplete="new-password"
          type={visible ? 'text' : 'password'}
          placeholder={placeholder}
          isInvalid={methods.errors?.[name]}
          focusBorderColor="black"
          ref={methods.register({
            required: true,
            // ref: https://stackoverflow.com/a/19605207
            pattern: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/,
          })}
        />
        <InputRightElement cursor="pointer">
          {visible ? (
            <Icon
              as={SvgVisibilityOffOutlined}
              boxSize="24px"
              color="gray.500"
              onClick={toggleVisible}
            />
          ) : (
            <Icon
              as={SvgVisibilityOutlined}
              boxSize="24px"
              color="gray.500"
              onClick={toggleVisible}
            />
          )}
        </InputRightElement>
      </InputGroup>
      {methods.errors?.[name]?.type === 'pattern' && (
        <Text color="red.500" fontSize="xs" data-testid="invalid-password">
          Password must be at least 8 characters, including one upper and lower
          case letter and one digit.
        </Text>
      )}
    </FormControl>
  );
}
